export class FluxData {
  icfr: number[];
  frequency: number;
  frequencies: number[] = new Array<number>();                // list of all the channel center frequencies for all us channels in the bonded group
  bandwidths: number[] = new Array<number>();                 // list of all the individual channel widths (1.6 MHz, 3.2 MHz, or 6.4 MHz) for all us channels
  icfrGraphPoints: number[][] = new Array<Array<number>>();
  phaseGraphPoints: number[][] = new Array<Array<number>>();
  delayGraphPoints: number[][] = new Array<Array<number>>();
}
